import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { CopyableValueRow } from './CopyableValueRow';
import { formatFingerprint } from './utils';

export function FingerprintRow({
    fingerprint,
}: {
    fingerprint: string | null;
}) {
    const { t } = useTranslation(I18nNamespace.SETTINGS);

    return (
        <CopyableValueRow
            label={t('license.machineFingerprint')}
            value={fingerprint}
            displayValue={formatFingerprint}
            unavailable={
                <span className="text-xs text-grey-300">
                    {t('license.fingerprintUnavailable')}
                </span>
            }
            status={null}
        />
    );
}
